import { createContext } from 'react';

const DEFAULT_VALUES = {
};

export const PeopleContext = createContext(DEFAULT_VALUES);
